import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ListSelectLocation } from 'components/ModalSelectLocation/ListSelectLocation';
import './ModalSelectLocation.scss';
import close from './img/close.svg';
const ModalSelectLocation = ({ onClose }) => {
    return (_jsx("div", Object.assign({ className: "modal-backdrop", onClick: onClose }, { children: _jsxs("div", Object.assign({ className: "modal-content", onClick: e => e.stopPropagation() }, { children: [_jsx(ListSelectLocation, {}), _jsx("button", Object.assign({ type: "button", className: "closeButton_wrap", onClick: onClose }, { children: _jsx("img", { className: "closeButton_icon", src: close, alt: "close" }) }))] })) })));
};
export default ModalSelectLocation;
